export default "__VITE_ASSET__BiPEwxhp__"